import React from 'react';
import CommanderPlanningFocus from './CommanderPlanningFocus';

export default function CommanderBriefContent({ commanderBrief, jumpToEvidence }) {
  return (
    <>
      <article className="commander-brief-summary">
        <h4>Executive Summary</h4>
        <p>{commanderBrief.executiveSummary}</p>
      </article>

      <div className="commander-brief-grid commander-brief-grid--operational">
        <section className="commander-brief-key-findings">
          <h4>Key Findings</h4>
          <ul className="commander-brief-finding-list">
            {(commanderBrief.keyFindings || []).map((finding, index) => (
              <li key={`${finding.title || 'finding'}-${index}`}>
                <span className={`commander-brief-severity is-${String(finding.severity || 'info').toLowerCase()}`}>
                  {finding.severity || 'Info'}
                </span>
                <strong>{finding.title}</strong>
                <p>{finding.details}</p>
                <small>{finding.evidence}</small>
                {(finding.evidenceLinks || []).length > 0 ? (
                  <div className="commander-brief-evidence-links">
                    {finding.evidenceLinks.map((link, linkIndex) => (
                      <button
                        key={`${link.type || 'evidence'}-${linkIndex}`}
                        type="button"
                        onClick={() => jumpToEvidence(link)}
                        title={link.description || link.label}
                      >
                        {link.label || 'View evidence'}
                      </button>
                    ))}
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
        </section>

        <div className="commander-brief-analysis-stack">
          <section>
            <h4>Likely Causes</h4>
            <ul className="commander-brief-bullets">
              {(commanderBrief.causalAssessment || []).map((item, index) => (
                <li key={`cause-${index}`}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h4>Near-Term Risk</h4>
            <ul className="commander-brief-bullets">
              {(commanderBrief.tomorrowRisk || []).map((item, index) => (
                <li key={`tomorrow-${index}`}>{item}</li>
              ))}
            </ul>
          </section>
        </div>
      </div>

      <CommanderPlanningFocus focus={commanderBrief.planningFocus} />

      {(commanderBrief.dataGaps || []).length > 0 && (
        <section className="commander-brief-data-gaps">
          <h4>Data Gaps / Confidence Notes</h4>
          <ul>
            {commanderBrief.dataGaps.map((item, index) => (
              <li key={`gap-${index}`}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      <section className="commander-brief-leader-actions">
        <h4>Recommended Leader Actions</h4>
        <ul className="commander-brief-bullets commander-brief-actions">
          {(commanderBrief.recommendedActions || []).map((item, index) => (
            <li key={`action-${index}`}>{item}</li>
          ))}
        </ul>
      </section>
    </>
  );
}
